<script setup>
import { omit } from 'lodash'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { useSettingsBackButton } from '@/composables/settings-back-button'
import { ROUTE_NAMES } from '@/routes/route-helpers'

import AppButton from '@/components/ui/AppButton/AppButton'
import SettingsPagesEmptyState from '@/components/ui/SettingsPagesEmptyState/SettingsPagesEmptyState'

defineOptions({
  name: 'CheckinFeedGeneralEmptyState'
})

const props = defineProps({
  isFiltersApplied: {
    type: Boolean
  }
})

const store = useStore()
const isPluginAdmin = computed(() => store.state.pluginOptions.isPluginAdmin)

const title = computed(() => {
  return props.isFiltersApplied
    ? 'checkins.feed.empty_state.title_with_filters'
    : 'checkins.feed.empty_state.title'
})

const message = computed(() => {
  return isPluginAdmin.value
    ? 'checkins.feed.empty_state.admin_message'
    : 'checkins.feed.empty_state.message'
})

const emit = defineEmits({
  'clear-filters': null
})

const router = useRouter()

const onActionClick = () => {
  if (props.isFiltersApplied) {
    emit('clear-filters')
  } else {
    goToSchedules()
  }
}

const { saveSettingsReferer } = useSettingsBackButton()

const goToSchedules = () => {
  saveSettingsReferer()
  router.push({ name: ROUTE_NAMES.SETTINGS_AUTOMATIONS })
}

const showAction = computed(() => {
  return props.isFiltersApplied ? true : isPluginAdmin.value
})

const actionAttrs = computed(() => {
  const attrs = {}

  if (props.isFiltersApplied) {
    attrs.text = 'filter.show_all'
  } else {
    attrs.text = 'checkins.feed.create_reminder'
    attrs.icon = 'plus-next'
    attrs.height = '24'
    attrs.width = '24'
  }

  return attrs
})
</script>

<template>
  <SettingsPagesEmptyState
    :style="{
      '--divider-color': isFiltersApplied ? 'transparent' : undefined
    }"
    data-testid="empty-state"
    hero-height="122"
    hero-icon="no-checkins-feed-general-hero"
    hero-width="341"
  >
    <template #title> {{ $t(title) }} </template>
    <template v-if="!isFiltersApplied" #subtitle> {{ $t(message) }} </template>

    <template v-if="showAction" #action>
      <AppButton
        data-testid="empty-state-create-button"
        v-bind="omit(actionAttrs, 'text')"
        @click="onActionClick"
      >
        {{ $t(actionAttrs.text) }}
      </AppButton>
    </template>
  </SettingsPagesEmptyState>
</template>

<style lang="scss" scoped></style>
